import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import AbattageElagage from "./pages/AbattageElagage";
import Paysagement from "./pages/Paysagement";
import TravauxForestiers from "./pages/TravauxForestiers";
import ServiceDetail from "./pages/ServiceDetail";
import { Toaster } from "./components/ui/sonner";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main className="main-content">
            <Routes>
              {/* Main Pages */}
              <Route path="/" element={<Home />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/realisations" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              
              {/* Service Category Pages */}
              <Route path="/abattage-elagage" element={<AbattageElagage />} />
              <Route path="/paysagement" element={<Paysagement />} />
              <Route path="/travaux-forestiers" element={<TravauxForestiers />} />
              
              {/* Individual Service Pages - Dynamic route with slug parameter */}
              <Route path="/:slug" element={<ServiceDetail />} />
              
              {/* Redirects for old URLs (301 equivalent in React Router) */}
              <Route path="/services" element={<Navigate to="/" replace />} />
              <Route path="/services/*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
